<template lang="pug">
    .examples-viewer
        .examples-viewer__examples
            .example(v-for="(example, index) in examplesArray")
                .example__container(:style="exampleStyle(index)")
                    .example__title
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_example') }} {{ index + 1 }}
                    .example__actions
                        span.example__operation_type_root(v-if="example.operation === 'root'")
                            | √
                        span(:class="{'example__action_border_overlined': example.operation === 'root'}")
                            span.example__action {{ getNumber(example) }}
                        sup(v-if="example.operation === 'square'")
                            | {{ 2 }}
                    .example__answer
                        | {{ $i18n.t('trainer.trainer_gamePlayBox_answer') }}: {{ getAnswer(example) }}
        .examples-viewer__button
            cs-button(
                color="blue"
                @click="$router.push({name: 'dashboard'})"
            )
                | {{ $i18n.t('common.common_navigation_goToMain') }}
</template>

<script>
    export default {
        props: {
            examplesArray: Array,
            fractionalPart: Number,
            fractions: Boolean,
            numbers: Boolean,
        },
        data() {
            return {
                colors: [
                    'hsl(121, 58%, 58%)',
                    'hsl(212, 100%, 56%)',
                    'hsl(15, 100%, 64%)',
                    'hsl(38, 100%, 56%)',
                    'hsl(331, 100%, 68%)',
                    'hsl(158, 62%, 54%)',
                    'hsl(284, 59%, 64%)',
                    'hsl(195, 86%, 64%)',
                ],
            };
        },
        methods: {
            getNumber(example) {
                return example.number;
            },
            getAnswer(example) {
                let answer = example.operation === 'square' ? Math.pow(example.number, 2) : Math.sqrt(example.number);
                let precision = 0;
                if (this.fractions) {
                    precision += this.fractionalPart;
                    if (example.operation === 'square') {
                        precision *= 2;
                    }
                }
                return +answer.toFixed(precision);
            },
            exampleStyle(index) {
                return { color: this.colors[index % this.colors.length] };
            },
        },
    };
</script>

<style lang="scss" scoped>
    .examples-viewer {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .examples-viewer__examples {
        display: flex;
        margin: -10px -10px 0;
        flex-wrap: wrap;
        flex-direction: row;
        justify-content: center;
        text-align: center;
        font-size: $font-size-24;
    }

    .example {
        padding: 10px;
    }

    .example__operation_type_root {
        font-size: 120%;
    }

    .example__action {
        filter: hue-rotate(10deg) saturate(50%);
    }

    .example__action_border_overlined {
        position: relative;
    }

    .example__action_border_overlined:after {
        position: absolute;
        content: '';
        border-top: 2px solid;
        top: -1px;
        left: -2px;
        right: -1px;
    }

    .example__container {
        background-color: $x-color-white;
        padding: 10px;
        border: 1px solid;
        border-radius: $border-radius-10;
    }

    .example__title,
    .example__answer {
        @include stack-space($space-x-small);
    }

    .examples-viewer__button {
        margin-top: 20px;
    }
</style>
